import React from 'react';
import './DeveloperInfo.css';

const DeveloperInfo = () => {
  return (
    <div className="developer-info">
      <div className="developer-content">
        <div className="developer-label">تطوير  وبرمجة:</div>
        <div className="developer-name">مصطفى أحمد </div>
        <a 
          href="tel:+966543641209" 
          className="developer-phone"
          title="اتصل بالمطور"
        >
          📱 0543641209
        </a>
      </div>
    </div>
  );
};

export default DeveloperInfo;

